export { default as Login } from './containers/Login';
export { default as Register } from './containers/Register';
export { default as ForgotPassword } from './containers/ForgotPassword';
export { default as ResetPassword } from './containers/ResetPassword';
export { default as ChangePassword } from './containers/ResetPassword';
export { default as VerifyEmail } from './containers/VerifyEmail';
export { default as FourZeroFour } from './containers/404';
